import { render, staticRenderFns } from "./BaseScrollCluster.vue?vue&type=template&id=5baa87a4&scoped=true&"
import script from "./BaseScrollCluster.vue?vue&type=script&lang=js&"
export * from "./BaseScrollCluster.vue?vue&type=script&lang=js&"
import style0 from "./BaseScrollCluster.vue?vue&type=style&index=0&id=5baa87a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../client_web_food_market/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5baa87a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Administrator\\Desktop\\gtzn\\FreeGoShop\\client_web_food_market\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5baa87a4', component.options)
    } else {
      api.reload('5baa87a4', component.options)
    }
    module.hot.accept("./BaseScrollCluster.vue?vue&type=template&id=5baa87a4&scoped=true&", function () {
      api.rerender('5baa87a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "client_web_common/base_components/BaseScrollCluster.vue"
export default component.exports